<div *ngIf="!isLoading" class="text-center d-flex flex-column justify-content-center w-100">
  <div class="py-3 align-self-center invoice" style="width: 80%;">
    <img src="{{
        successful ? 'assets/img/check-circle-fill.png' : 'assets/svg/failure.svg'
      }}" height="70" class="mt-3 mb-4" />
    <h2 class="mb-4">
      {{
      successful
      ? this.role === 'ENTERPRISE' ? "Compra de saldo exitosa" : 'Pago de exitoso'
      : "Orden de Compra XXXXXXX rechazada"
      }}
    </h2>
    <div *ngIf="successful; else error">
      <div class="mb-3">
        <div class="bold">Número de orden</div>
        <div>{{ transactionStatus.buyOrder }}</div>
      </div>
      <div class="mb-3">
        <div class="bold">Nombre del comercio</div>
        <div>{{ transactionStatus.companyName }}</div>
      </div>
      <div class="mb-3">
        <div class="bold">Monto de la transacción</div>
        <div>{{ transactionStatus.amount | currency: "CLP":"":"1.0" }}</div>
      </div>
      <div class="mb-3">
        <div class="bold">Descripción</div>
        <div>{{ this.role === 'ENTERPRISE' ? 'Recarga de saldo' : 'Pago de facturas'}}</div>
      </div>
      <div class="d-flex justify-content-center mb-3 mt-4">
        <a (click)="reloadPage()" style="text-decoration: none; color: white; width: 100%;"
          class="btn btn-dark h-auto mt-2 p-3 px-5">Aceptar</a>
      </div>
    </div>
    <ng-template #error>
      <div class="error">
        <p class="bold">Las posibles causas de este rechazo son:</p>
        <p>
          * Error en el ingreso de los datos de tu tarjeta de crédito o débito
        </p>
        <p>(fecha y/o código de seguridad)</p>
        <p>* Su tarjeta de crédito o débito no cuenta con saldo suficiente.</p>
        <p>* Tarjeta aún no habilitada en el sistema financiero.</p>
        <div class="d-flex justify-content-center mb-3 mt-2">
          <a href="/payments" class="btn btn-danger px-5 mt-2">Reintentar</a>
        </div>
      </div>
    </ng-template>
  </div>
</div>
